import React, { useState, useCallback } from 'react';
import WaitingContext from './WaitingContext';
import { waitingService } from '../../services/waiting/waitingService';

export const WaitingState = ({ children }) => {
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [isChecking, setIsChecking] = useState(false);

  const checkApprovalStatus = useCallback(async (identifier) => {
    try {
      setIsChecking(true);
      const res = await waitingService.checkApprovalStatus(identifier);
      setApprovalStatus(res);
      return res;
    } catch (error) {
      console.error('Failed to check approval status:', error);
      throw error;
    } finally {
      setIsChecking(false);
    }
  }, []);

  const value = {
    approvalStatus,
    setApprovalStatus,
    isChecking,
    checkApprovalStatus
  };

  return (
    <WaitingContext.Provider value={value}>
      {children}
    </WaitingContext.Provider>
  );
};

export default WaitingState;
